import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UsersService } from 'src/app/services/users.service';
import { CurrentUserService } from 'src/app/services/current-user.service';
import { ISiteUserInfo } from '@pnp/sp/site-users/types';
import { UserRequestDetails } from '../services/models';

@Component({
  selector: 'app-access-request',
  templateUrl: './access-request.component.html'
})
export class AccessRequestComponent implements OnInit  {
  canload = false;
  buttonSubmitEnabled = true;
  user: ISiteUserInfo;
  requestDetails: UserRequestDetails= { jurisdiction: "Global",
                                        area: null,
                                        country: null,
                                        marketAccessFunction: true,
                                        functionDescription: null,
                                        fieldFacing: false };

  constructor(
    private router: Router,
    private currentUserService: CurrentUserService,
    private usersService: UsersService ) { }

    async ngOnInit(): Promise<void> {
      // Test if the user has an pending access request
      this.user = await this.currentUserService.get();
      const userAccessRequests = await this.usersService.getUserAccessRequest(this.user.Id);
      if(userAccessRequests && !this.user.IsAccessHubMember) {
        this.router.navigateByUrl('/account/access-request-already');
      } else if(this.user.IsAccessHubMember) {
        this.router.navigateByUrl('/');
      }
      this.canload = true;
    }

    updateJurisdiction(e) {
      this.requestDetails.jurisdiction = e.target.value;
      this.requestDetails.area = null;
      this.requestDetails.country = null;
      this.validate();
    }

    async submit(): Promise<void>{
      await this.usersService.storeAccessRequest(this.user.Title,JSON.stringify(this.requestDetails));
      this.router.navigateByUrl('/account/access-request-submitted');
    }

    validate() {
      if(!this.requestDetails.marketAccessFunction && (this.requestDetails.functionDescription == null || this.requestDetails.functionDescription == '')) {
        this.buttonSubmitEnabled = false;
      } else if(this.requestDetails.jurisdiction == 'Affiliate' && (this.requestDetails.country == null || this.requestDetails.country == '')) {
        this.buttonSubmitEnabled = false;
      }
      else if(this.requestDetails.jurisdiction == 'Area' && (this.requestDetails.area == null || this.requestDetails.area == '')) {
        this.buttonSubmitEnabled = false;
      }
      else {
        this.buttonSubmitEnabled = true;
      }
    }
}
